package com.patronat.top.client.presentation.onboarding

import com.patronat.top.ui.theme.AppImages
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.onboarding_discover_description
import top.clientapp.generated.resources.onboarding_discover_title
import top.clientapp.generated.resources.onboarding_filters_map_description
import top.clientapp.generated.resources.onboarding_filters_map_title
import top.clientapp.generated.resources.onboarding_reviews_description
import top.clientapp.generated.resources.onboarding_reviews_title
import top.clientapp.generated.resources.onboarding_share_description
import top.clientapp.generated.resources.onboarding_share_title
import top.clientapp.generated.resources.onboarding_start_description
import top.clientapp.generated.resources.onboarding_start_title

internal data class OnboardingPage(
    val image: DrawableResource,
    val title: StringResource,
    val description: StringResource
)

internal val onboardingPages = listOf(
    OnboardingPage(
        image = AppImages.OnboardingDiscover,
        title = Res.string.onboarding_discover_title,
        description = Res.string.onboarding_discover_description
    ),
    OnboardingPage(
        image = AppImages.OnboardingReviews,
        title = Res.string.onboarding_reviews_title,
        description = Res.string.onboarding_reviews_description
    ),
    OnboardingPage(
        image = AppImages.OnboardingShare,
        title = Res.string.onboarding_share_title,
        description = Res.string.onboarding_share_description
    ),
    OnboardingPage(
        image = AppImages.OnboardingFiltersMap,
        title = Res.string.onboarding_filters_map_title,
        description = Res.string.onboarding_filters_map_description
    ),
    OnboardingPage(
        image = AppImages.OnboardingStart,
        title = Res.string.onboarding_start_title,
        description = Res.string.onboarding_start_description
    )
)
